const PastSaBt: React.FC<{
    isSelected: boolean;
}> = ({ isSelected }) => {
    const isFilled = false;
    return (
        <div className={`menuitem ${isFilled ? 'filled' : ''} ${isSelected ? 'selected' : ''}`}>
            <div>
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        className="w-16 h-16"
                    >
                        <path d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z" />
                    </svg>
                </div>
                <p>Assessment Responses</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    {isFilled ? (
                        <path d="M10.0547 16.8125C10.2891 17.0469 10.6875 17.0469 10.9219 16.8125L17.8125 9.92188C18.0469 9.6875 18.0469 9.28906 17.8125 9.05469L16.9688 8.21094C16.7344 7.97656 16.3594 7.97656 16.125 8.21094L10.5 13.8359L7.85156 11.2109C7.61719 10.9766 7.24219 10.9766 7.00781 11.2109L6.16406 12.0547C5.92969 12.2891 5.92969 12.6875 6.16406 12.9219L10.0547 16.8125Z"></path>
                    ) : (
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                    )}
                </svg>
            </div>
        </div>
    );
};

export default PastSaBt;
